import Vue from "vue";
import Vuex from "vuex";
import SharedModules from "./modules/SharedModules";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    SharedModules,
  },
  plugins: [createPersistedState()],
});
